import { render, staticRenderFns } from "./HeadListNav.vue?vue&type=template&id=2f5c2e24&scoped=true"
import script from "./HeadListNav.vue?vue&type=script&lang=js"
export * from "./HeadListNav.vue?vue&type=script&lang=js"
import style0 from "./HeadListNav.vue?vue&type=style&index=0&id=2f5c2e24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5c2e24",
  null
  
)

export default component.exports